import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedAssetsImport = _resolveComponent("FixedAssetsImport")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialog) = $event)),
    minWidth: _ctx.width,
    actions: _ctx.actions,
    title: "Importez votre fichier",
    "valid-loading": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.wizardStep,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wizardStep) = $event)),
        touchless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, {
            value: 0,
            class: "py-3"
          }, {
            default: _withCtx(() => [
              (_ctx.wizardStep === 0)
                ? (_openBlock(), _createBlock(_component_FixedAssetsImport, {
                    key: 0,
                    ref: "importComponent",
                    documentType: 'FIXED_ASSETS',
                    actions: _ctx.actions,
                    onDocumentImported: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDocumentImported($event))),
                    "min-width": _ctx.width
                  }, null, 8, ["actions", "min-width"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, {
            value: 2,
            class: "py-0"
          }, {
            default: _withCtx(() => [
              (
                        _ctx.currentUser.profile.configuration.bankTransaction.import && _ctx.wizardStep === 2
                    )
                ? (_openBlock(), _createBlock(_component_UploadDocuments, {
                    key: 0,
                    showFirstPrevious: true,
                    companyId: _ctx.companyId,
                    documentType: 'BANK_STATEMENT',
                    multiple: true,
                    freeTag: false,
                    inExtensions: ['pdf'],
                    actions: _ctx.actions,
                    onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back())),
                    onFilesUploaded: _ctx.imported,
                    onNewDocument: _ctx.imported,
                    "min-width": _ctx.width
                  }, null, 8, ["companyId", "actions", "onFilesUploaded", "onNewDocument", "min-width"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "minWidth", "actions"]))
}